import { useState, useContext } from 'react';
import { isEmpty, uniqBy } from 'lodash';
import { parametersApi } from 'api';
import { AssetContext, GlobalTypesContext } from 'context';

export default (type, columnIndex) => {
  const { id, name, parentAssetSubTypeId, isSubType } = type;
  const typeId = parentAssetSubTypeId?.id || id;
  const [assetsLoading, setAssetsLoading] = useState(false);
  const [error, setError] = useState('');
  const { hiddenAssetSubTypes } = useContext(GlobalTypesContext);
  const { assetManipulation, setAssetManipulation } = useContext(AssetContext);

  const loadAssetSubTypes = async () => {
    setAssetsLoading(true);
    const array = [];

    const getSubTypes = async after => {
      const query = { asset_type_id: id, sort_by: 'name', order: 'asc' };
      if (after) query.after = after;
      try {
        const response = await parametersApi('getAssetSubTypes', query);
        const { assetSubTypes, paging } = response;
        if (assetSubTypes) {
          const filteredSubTypes = assetSubTypes?.filter(
            subType => !hiddenAssetSubTypes.includes(subType.id)
          );
          array.push(...filteredSubTypes);
        }
        if (paging?.cursors?.after) {
          await getSubTypes(paging?.cursors?.after);
        }
      } catch (err) {
        setError(err);
      }
      return array;
    };
    if (!isSubType) {
      setAssetsLoading(false);
      setAssetManipulation(curr => {
        curr.isAddingNew[`${name}-${columnIndex}`] = true;
      });
      return;
    }

    const assetSubTypesList = await getSubTypes();
    if (!isEmpty(assetSubTypesList) && id) {
      const removeInvalidChildrenTypes = assetSubTypesList.filter(subType => {
        return (
          subType.parentAssetSubTypeId === type?.parentAssetSubTypeId?.id ||
          subType.parentAssetSubTypeId === null
        );
      });
      if (isEmpty(removeInvalidChildrenTypes)) {
        setAssetManipulation(curr => {
          curr.isAddingNew[`${name}-${columnIndex}`] = false;
          curr.hasSubTypes[typeId] = [];
        });
      } else {
        setAssetManipulation(curr => {
          curr.isAddingNew[`${name}-${columnIndex}`] = true;
          curr.isOpen[`${name}-${columnIndex}`] = true;
          if (isEmpty(curr.hasSubTypes[typeId])) {
            curr.hasSubTypes[typeId] = uniqBy(
              [...removeInvalidChildrenTypes],
              'id'
            );
          } else {
            curr.hasSubTypes[typeId] = uniqBy(
              [...curr.hasSubTypes[typeId], ...removeInvalidChildrenTypes],
              'id'
            );
          }
        });
      }
    }
    setAssetsLoading(false);
  };

  return {
    loadAssetSubTypes,
    assetsLoading,
    setAssetsLoading,
    error,
    assetManipulation,
  };
};
